export default "__VITE_ASSET__5a5d3d23__"